import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { createContext, useState, useContext } from "react";

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");

  return (
    <LoadingContext.Provider value={{ loading, setLoading, setLoadingMessage }}>
      {children}
      <LoadingDialog open={loading} message={loadingMessage} />
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);

const LoadingDialog = ({ open, message }) => (
  <Dialog open={open}>
    <DialogContent>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {message}
        </Typography>
      </Box>
    </DialogContent>
  </Dialog>
);
